import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

interface NotificationInterface {
  id: any;
  title: string;
  body: string;
  orderId?: string;
  orderStatus?: string;
  timestamp: number;
  // For foreground notifications
  notification?: {
    title: string;
    body: string;
  };
  data?: {
    orderId?: string;
    orderStatus?: string;
  };
}

const Notification = () => {
  const notifications = useSelector((state: any) => state.notification.notifications);
  const [shownNotificationKeys, setShownNotificationKeys] = useState<Set<string>>(new Set());

  useEffect(() => {
    notifications.forEach((notification: NotificationInterface) => {
      // Handle both foreground and background formats
      const effectiveNotification = {
        id: notification.id,
        title: notification.notification?.title || notification.title,
        body: notification.notification?.body || notification.body,
        orderId: notification.data?.orderId || notification.orderId,
        orderStatus: notification.data?.orderStatus || notification.orderStatus,
        timestamp: notification.timestamp || Date.now()
      };

      if (!effectiveNotification.orderStatus) {
        return;
      }

      const notificationKey = `${effectiveNotification.id}-${effectiveNotification.orderStatus}`;

      if (shownNotificationKeys.has(notificationKey)) {
        return;
      }

      toast.success(`Order ${effectiveNotification.orderId} is now ${effectiveNotification.orderStatus}`);
      setShownNotificationKeys((prev) => new Set(prev).add(notificationKey));
    });
  }, [notifications, shownNotificationKeys]);

  return null;
};

export default Notification;